import { getTermSetsByIds } from '../../sharePoint/sharePointHelper';
import { paramDsNameDest, paramDsNameSrc } from '../constants/parameterNames';
import { typeDataSource } from '../constants/parameterTypes';
import makeTaxonomyNamespaces from '../helpers/taxonomyNamespaces';
import { getNodeValue } from '../../../xmlUtility';

const $ = window.jQuery;

const requiredParameters = [];
const optionalParameters = [
    {
        name: paramDsNameSrc,
        description: 'GetTermSet data connection',
        type: typeDataSource,
    },
    {
        name: paramDsNameDest,
        description: 'Destination source',
        type: typeDataSource,
    },
];
const description =
    'Queries SharePoint’s TaxonomyClientService to obtain a list of available TermSets. Additional information on the metadata commands can be found on http://www.infopathdev.com/files/folders/qrules/entry76371.aspx. This command takes no parameters.';

const getTermSetsErrorNoResults = 'GetTermSets returned no result';
const ERROR_NO_IDS = 'Cannot execute query. No TermSet ids were found.';

function GetTermSets(params) {
    const cf = params.commonFunctions;
    const taxonomyNamespaces = makeTaxonomyNamespaces();

    function getNode(dataSource, xPath) {
        return dataSource.selectSingle(xPath, {
            namespaces: taxonomyNamespaces,
        });
    }

    function getDsNodeValue(dataSource, xPath) {
        const node = getNode(dataSource, xPath);

        if (!node) {
            return null;
        }

        return node.value();
    }

    async function setTaxonomyResultAsync(termStoreDoc, dsNameDest) {
        const dsDest = cf.getDataSource(dsNameDest);
        const xpathResult = '/ns1:QdabraRulesTermSets/ns1:GetTermSets';
        const hasTerms = params.xpathEngine
            .evaluateXPath('*/tns:TermStore/tns:T', {
                context: termStoreDoc,
                namespaces: taxonomyNamespaces,
            })
            .booleanValue();

        if (!hasTerms) {
            return {
                error: getTermSetsErrorNoResults,
                success: false,
            };
        }

        const rootDest = getNode(dsDest, xpathResult);

        await rootDest.setContentAsync(termStoreDoc.documentElement);

        return {
            success: true,
        };
    }

    const determineSiteUrl = (dcTermSets) => {
        const dcUrl = dcTermSets.getUrl();
        const matchIndex = dcUrl.search(
            new RegExp('/_vti_bin/taxonomyclientservice.asmx', 'i'),
        );

        if (matchIndex) {
            return dcUrl.substr(0, matchIndex);
        }

        return dcUrl;
    };

    const getTermSetIds = (dsSource) => {
        const termSetIdsValue = getDsNodeValue(
            dsSource,
            '/dfs:myFields/dfs:queryFields/tns:GetTermSets/tns:termSetIds',
        );

        if (!termSetIdsValue) {
            throw new Error(ERROR_NO_IDS);
        }

        const termSetIdsXml = $.parseXML(termSetIdsValue);

        return params.xpathEngine
            .evaluateXPath('termSetIds/termSetId', {
                context: termSetIdsXml,
            })
            .toArray()
            .map(getNodeValue);
    };

    async function executeAsync() {
        const shp = params.shpAccess;
        const dsNameSrc = cf.getParamValue(paramDsNameSrc, 'GetTermSets');
        const dsNameDest = cf.getParamValue(
            paramDsNameDest,
            'QdabraRules_TermSets',
        );
        const dcTermSets = cf.getDataConnection(dsNameSrc);
        const dsSource = cf.getDataSource(dsNameSrc);

        const siteUrl = determineSiteUrl(dcTermSets);

        const termSetIds = getTermSetIds(dsSource);
        const termsetsLcid = getDsNodeValue(
            dsSource,
            '/dfs:myFields/dfs:queryFields/tns:GetTermSets/tns:lcid',
        );

        if (!termSetIds.length) {
            return {
                error: 'Cannot execute query. No TermSet IDs are present.',
            };
        }

        const termSetXml = await getTermSetsByIds(
            shp,
            siteUrl,
            termsetsLcid,
            termSetIds,
        );

        const commandResult = await setTaxonomyResultAsync(
            termSetXml,
            dsNameDest,
        );

        return commandResult;
    }

    return {
        description,
        executeAsync,
        optionalParameters,
        requiredParameters,
    };
}

export default GetTermSets;
